// extracted by mini-css-extract-plugin
export default {"buttonlink":"ButtonLink_buttonlink__N3eBj","medium":"ButtonLink_medium__0JMo7","reverse":"ButtonLink_reverse__lkrY4"};